import {KitTypes} from "../../../packages/downloadKitButtonSelector/constants";

export enum Column {
  VERSION,
  STAGING_PROFILE,
  VERSION_PUBLISHED,
  LAST_MODIFIED,
  VENDOR_RINGS,
  HAS_KIT,
}

export enum ColumnKeys {
  VERSION= 'version',
  VENDOR_RINGS = 'vendorRings',
  STAGING_PROFILE = 'stagingProfile',
  VERSION_PUBLISHED = 'publishInfo',
  HAS_KIT = 'hasKit',
  LAST_MODIFIED = 'lastModified'
}

export enum CloudStagingListEvents {
  REFRESH_COMPONENT = 'refreshCloudStagingListComponent',
  SHOW_OS = 'showOs',
}

export enum osTypes {
  linux = KitTypes.KIT_ID_SECURITY_TOOLS_LINUX,
  windows = KitTypes.KIT_ID_SECURITY_TOOLS_WIN,
  mac = KitTypes.KIT_ID_ENDPOINT_CLIENT_MAC,
}
